'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import { ArrowLeft } from 'lucide-react';
import { MobileMenuButton } from '@/components/ui/mobile-menu-button';

interface EpisodeHeaderProps {
  title: string;
  onLogin: () => void;
}

export function EpisodeHeader({ title }: EpisodeHeaderProps) {
  const router = useRouter();

  const handleBack = React.useCallback(() => {
    if (typeof window !== 'undefined' && window.history.length > 1) {
      router.back();
      return;
    }

    router.push('/episodes');
  }, [router]);

  return (
    <div className="hidden sm:block">
      <MobileMenuButton ariaLabel="Open menu" />
      <div className="sticky top-0 z-50 bg-background sm:border-none border-b border-border py-2">
        <div className="flex items-center justify-between px-2 sm:px-6 py-0">
          <div className="flex items-center space-x-0 sm:space-x-0">
            <button
              type="button"
              onClick={handleBack}
              aria-label="Go back"
              className="text-muted-foreground px-1 rounded hover:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            >
              <ArrowLeft className="h-5 w-5" />
            </button>
            <div className="flex items-center space-x-3">
              <span className="text-md text-muted-foreground hidden sm:inline pl-2">
                Episodes
              </span>
              <span className="text-muted-foreground hidden sm:inline">|</span>
              <h1 className="font-medium text-md text-muted-foreground max-w-[210px] sm:max-w-[300px] md:max-w-[400px] truncate">
                {title}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
